import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getDebugDialogOpen } from '../../Selectors'
import { VNDialog } from '../../../VNCustomerFacingDisplay/components/VNDialog'
import styles from './VNDebugDialog.module.scss'
import VNBlueSwitch from '../../../components/VNBlueSwitch'
import { setDebugDialogOpen } from '../../ActionCreators'
import {
  getCardReaderError,
  getDebuggerPassthroughEnabled,
  getSimulateDisconnection,
  getVNDebuggerEnabled,
} from '../../../VNTestMode/Selectors'
import {
  setCardReaderError,
  setDebuggerPassthroughEnabled,
  setSimulateDisconnect,
  setVNDebuggerEnabled,
} from '../../../VNTestMode/ActionCreators'
import { getDeviceMode } from '../../../VNMode/Selectors'
import { MODES } from '../../../VNMode/Reducer'
import { bridge_enableLogPassthrough } from '../../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'

export const VNDebugDialog = () => {
  const dispatch = useDispatch()
  const open = useSelector(getDebugDialogOpen)
  const isVNDebuggerEnabled = useSelector(getVNDebuggerEnabled)
  const simulateDisconnections = useSelector(getSimulateDisconnection)
  const cardReaderError = useSelector(getCardReaderError)
  const debugPassthroughEnabled = useSelector(getDebuggerPassthroughEnabled)
  const cfdMode = useSelector(getDeviceMode)

  const RenderSettings = ({ disabled, name, onClick, isChecked }) => {
    return (
      <div className={styles.record}>
        <div className={styles.menuDetails} style={{ width: '100%', justifyContent: 'space-between' }}>
          <div className={styles.svgIconContainer} style={{ width: '100%', justifyContent: 'left' }}>
            {name}
          </div>
          <div className={styles.svgIconContainer}>
            <VNBlueSwitch disabled={disabled} onClick={onClick} checked={isChecked} />
          </div>
        </div>
      </div>
    )
  }

  useEffect(() => {
    if (simulateDisconnections && window.Broadcaster) {
      window.disabledBroadcaster = window.Broadcaster
      window.Broadcaster = null
      return
    }

    if (window.disabledBroadcaster) {
      window.Broadcaster = window.disabledBroadcaster
    }
  }, [simulateDisconnections])

  const onDebugPassthroughChange = (e) => {
    const value = e.target.checked
    dispatch(setDebuggerPassthroughEnabled(value))
    bridge_enableLogPassthrough(value)
  }

  const displayOptions = () => {
    return (
      <div className={styles.debugDialog}>
        {RenderSettings({
          disabled: !debugPassthroughEnabled,
          name: 'Enable VN Debugger',
          onClick: () => {
            dispatch(setVNDebuggerEnabled(!isVNDebuggerEnabled))
          },
          isChecked: isVNDebuggerEnabled,
        })}
        {RenderSettings({
          disabled: cfdMode !== MODES.POS,
          name: 'Simulate Disconnection',
          onClick: () => {
            dispatch(setSimulateDisconnect(!simulateDisconnections))
          },
          isChecked: simulateDisconnections,
        })}
        {RenderSettings({
          disabled: false,
          name: 'Simulate Card Reader Error',
          onClick: () => {
            dispatch(setCardReaderError(!cardReaderError))
          },
          isChecked: cardReaderError,
        })}
        {RenderSettings({
          disabled: false,
          name: 'Enable Debug Passthrough',
          onClick: onDebugPassthroughChange,
          isChecked: debugPassthroughEnabled,
        })}
      </div>
    )
  }

  return (
    <VNDialog
      open={open}
      image={displayOptions()}
      primaryButtonText={'Done'}
      onPrimaryButtonClick={() => {
        dispatch(setDebugDialogOpen(false))
      }}
      height={'auto'}
    />
  )
}
